import { createSlice } from '@reduxjs/toolkit';
import { selectHolidays as selectHolidaysFromCritical, selectCriticalDataLoading, selectCriticalDataError } from './criticalDataSlice';

/**
 * DEPRECATED: This slice is maintained for backward compatibility
 * Holidays now come from criticalDataSlice via unified /critical-data endpoint
 * Components should use criticalDataSlice selectors directly or call fetchAllCriticalData
 */

const initialState = {
  holidays: [],
  loading: false,
  error: null,
};

const holidaysSlice = createSlice({
  name: 'holidays',
  initialState,
  reducers: {
    setHolidays: (state, action) => {
      state.holidays = action.payload;
      state.loading = false;
      state.error = null;
    },
    setHolidaysLoading: (state, action) => {
      state.loading = action.payload;
    },
    setHolidaysError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearHolidays: (state) => {
      state.holidays = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setHolidays, setHolidaysLoading, setHolidaysError, clearHolidays } = holidaysSlice.actions;

// Selectors - proxy to criticalDataSlice
export const selectHolidays = (state) => {
  // Try to get from criticalDataSlice first
  const criticalData = selectHolidaysFromCritical(state);
  if (Array.isArray(criticalData)) {
    return criticalData;
  }
  // Fallback to local state for backward compatibility
  return state.holidays.holidays;
};

export const selectHolidaysLoading = (state) => {
  // Map criticalData loading to local loading
  const loading = selectCriticalDataLoading(state);
  if (loading) return true;
  
  return state.holidays.loading;
};

export const selectHolidaysError = (state) => {
  const criticalError = selectCriticalDataError(state);
  return criticalError || state.holidays.error;
};

export default holidaysSlice.reducer;
